import { useUserInfoStore } from '../stores/userInfoStore'

const getMineUrl = () => {
    const userInfoStore = useUserInfoStore()
    if(userInfoStore.info){
        console.log("getMineUrl userInfoStore.info", userInfoStore.info)
        switch(userInfoStore.info.user_type){
            case 'hm_employee':
            case '华美员工':
                return `/startPage/homeHuamei`
            case 'partner':
            case '合作伙伴':
                return `/startPage/homePartners`
            case 'group':
            case '集团':
                return `/startPage/homeGroup`
            case 'new_hotel':
            case '新建酒店':
            case '咨询服务':
                return `/startPage/homeConsult`
            case 'open_hotel':
            case '开业酒店':
                return `/startPage/homeHotel`
            default:
                return `/login`
        }
    }
    else{
        return `/login`
    }
}
export default defineNuxtRouteMiddleware((to, from) => {
    if (to.path === '/startPage/home') {
      return navigateTo(getMineUrl())
    }
  })


